jQuery.fn.maxlength = function (options) {
	var settings = jQuery.extend({
		maxChars: 10,
		leftChars: 'character left',
		useBorder: true,
		errorBorder: '1px solid #7c0000',
		okBorder: '1px solid #9F9F9F',
		fieldForCounter: false,
		fieldForCounterType: 'span',
		Counter: false,
		CounterField: '',
		CounterBeginText: 'осталось ',
		CounterEndText: ' символов',
		CounterTextColor: '#787878',
		CounterAction: 'insertAfter',
		CounterClass: '',
		useBR: false
	}, options);

	return this.each(function () {
		var field = $(this);
		var l = settings.maxChars;

		field
			.bind('keydown keypress keyup', function (e) {
				// new code for delete ' ' on first symbol 21.05.2015 i.zuev
				if (field.val()[0] === ' ') {
					field.val('');
				}
				// end
				if (field.val().length > settings.maxChars) {
					field.val(field.val().substr(0, settings.maxChars));
					$('span#counter').addClass('animated shake');

					if (settings.useBorder) {
						field.css('border', settings.errorBorder);
					}
				} else {
					$('span#counter').removeClass('animated shake');
					if (settings.useBorder) {
						field.css('border', settings.okBorder);
					}
				}

				if (settings.Counter) {
					l = settings.maxChars - field.val().length;
					//field.next('div').html(l + ' ' + settings.leftChars);

					if (settings.CounterField.length > 0) {
						var _field = $(settings.CounterField);

						switch (settings.CounterAction) {
							case 'replaceWith':
								if (_field.find('span#counter').length === 0) {
									$('<span id="counter"' + (settings.CounterClass.length > 0 ? ' class="' + settings.CounterClass + '"' : '') + '></span>')
										.appendTo(_field);
								}
								_field
									.find('span#counter')
									.html((settings.useBR ? '<br>' : '') + settings.CounterBeginText + l + settings.CounterEndText)
									.css('color', settings.CounterTextColor)
									.show();
							break;

							default:
								if (_field.next('span#counter').length === 0) {
									$('<span id="counter"' + (settings.CounterClass.length > 0 ? ' class="' + settings.CounterClass + '"' : '') + '></span>')
										.insertAfter(_field);
								}

								_field
									.next('span#counter')
									.html((settings.useBR ? '<br>' : '') + settings.CounterBeginText + l + settings.CounterEndText)
									.css('color', settings.CounterTextColor)
									.show();
						}
					} else {
						if (field.next('span').length == 0) {
							switch (settings.CounterAction) {
								case 'replaceWith':
									field.replaceWith('<span id="counter"></span>');
								break;

								default:
									$('<span id="counter"></span>').insertAfter(field);
							}
						}

						switch (settings.CounterAction) {
							case 'replaceWith':
								field
									.find('span#counter')
									.html((settings.useBR ? '<br>' : '') + settings.CounterBeginText + l + settings.CounterEndText)
									.css('color', settings.CounterTextColor)
									.show();
							break;

							default:
								field
									.next('span#counter')
									.html((settings.useBR ? '<br>' : '') + settings.CounterBeginText + l + settings.CounterEndText)
									.css('color', settings.CounterTextColor)
									.show();
						}

						if (settings.CounterClass.length > 0) {
							field
								.next('span#counter').addClass(settings.CounterClass);
						}
					}
				}
			})
			.focusout(function () {
				switch (settings.CounterAction) {
					case 'replaceWith':
						field.find('span#counter').hide();
					break;

					default:
						field.next('span#counter').hide();
				}
			});
		//field.after('<div class="maxlen">' + settings.maxChars + ' ' + settings.leftChars + '</div>');
	});
};



/** WEBPACK FOOTER **
 ** ./frontend/components/error-report/jquery.maxlength-short.js
 **/